export enum IntegrationStatus {
  UNLINKED = 'Unlinked',
  PENDING_AUTH = 'PendingAuth',
  MISSING_DETAILS = 'MissingDetails',
  SYNCING = 'Syncing',
  LINKED = 'Linked',
  DEAUTHORIZED = 'Deauthorized',
  DISCONNECTED = 'Disconnected',
}
